import React from 'react';
import Link, { LINK_BEHAVIORS, LINK_TYPES } from 'components/Link';
import ResponsiveImage, {
  transforms as responsiveImageTransforms,
} from 'components/ResponsiveImage';
import PropTypes from 'prop-types';
import cn from 'classnames';

const MarketAccessCtaWithIcon = ({ link, icon }) => {
  if (!link) return null;

  return (
    <a
      href={link.url}
      target={link.openInNewTab ? '_blank' : null}
      rel={link.openInNewTab ? 'noopener noreferrer' : null}
      className={cn('market-access-cta-with-icon', {
        'market-access-cta-with-icon_restricted':
          link.type === LINK_TYPES.restricted,
      })}
    >
      {icon && (
        <div className="market-access-cta-with-icon__icon-holder">
          <ResponsiveImage
            {...icon}
            loading="lazy"
            transform={responsiveImageTransforms.fit}
            sources={[
              {
                width: 32,
                height: 32,
              },
            ]}
            className="market-access-cta-with-icon__icon"
          />
        </div>
      )}
      <Link
        text={link.text}
        type={link.type}
        behavior={LINK_BEHAVIORS.card}
        className="market-access-cta-with-icon__heading"
      />
    </a>
  );
};

MarketAccessCtaWithIcon.propTypes = {
  link: PropTypes.exact(Link.propTypes),
  icon: PropTypes.exact(ResponsiveImage.propTypes),
};

export default MarketAccessCtaWithIcon;
